import { Component, Input } from '@angular/core';
import { IlSession } from '@queries/generated';
import { sessionsForToday } from '@util/session-dates';

type IlShowClassSessionsType = 'today' | 'first' | 'last' | 'nearest' | number;

@Component({
  selector: 'vnm-il-class-sessions-cell',
  templateUrl: './il-class-sessions-cell.component.html',
  styleUrls: ['./il-class-sessions-cell.component.scss']
})
export class IlClassSessionsCellComponent {
  @Input() sessions: IlSession[];
  @Input() onlyShow: IlShowClassSessionsType;
  @Input() showLocation = false;
  @Input() hideLocationUrl = false;

  get hasSessions(): boolean {
    return this.sessionList.length > 0;
  }

  get sessionList() {
    const { onlyShow } = this;

    if (onlyShow === 'today') {
      return sessionsForToday(this.sessions);
    } else if (onlyShow === 'first') {
      return [this.sessions[0]];
    } else if (onlyShow === 'last') {
      return [this.sessions[this.sessions.length - 1]];
    } else if (typeof onlyShow === 'number') {
      return [this.sessions[onlyShow]];
    }

    return this.sessions || [];
  }
}
